import {VIBRATE_TIME} from '../../ClickerGame.constants';
import {DI_TOKENS} from '@/di/di.tokens';
import {FederatedPointerEvent} from 'pixi.js';

import {injected} from 'brandi';

import {BaseComponent, GameObject, HealthComponent, IGameWorld} from '@specials/gcs-engine';

import {Vibration} from '@/utils/Vibration';

import {ClickerAudioPlayer, ClickerSoundsBundle} from '../../ClickerAudioPlayer';
import {ClickerGameEventNames, ClickerGameEvents} from '../../ClickerGameEvents';
import {BonusDestroyEffect} from '../BonusDestroyEffect/BonusDestroyEffect';
import {Spaceship} from '../Spaceship/Spaceship';
import {AsteroidDataComponent} from './AsteroidDataComponent';
import {AsteroidViewComponent} from './AsteroidViewComponent';

export class AsteroidInteractiveComponent extends BaseComponent {
  private viewComponent?: AsteroidViewComponent;
  private healthComponent?: HealthComponent;
  private destroyEffect?: BonusDestroyEffect;
  private spaceship?: Spaceship;
  private dataComponent?: AsteroidDataComponent;

  constructor(
    private readonly audioPlayer: ClickerAudioPlayer,
    private readonly clickerEvents: ClickerGameEvents,
    private readonly vibration: Vibration,
  ) {
    super();
  }

  public onAddToGameObject(go: GameObject): void {
    this.viewComponent = go.getComponent(AsteroidViewComponent);
    this.healthComponent = go.getComponent(HealthComponent);
    this.dataComponent = go.getComponent(AsteroidDataComponent);
  }

  public onAddToWorld(world: IGameWorld): void {
    this.destroyEffect = world.getGameObject(BonusDestroyEffect);

    this.spaceship = world.getGameObject(Spaceship);

    if (!this.viewComponent) return;

    this.viewComponent.view.cursor = 'pointer';
    this.viewComponent.view.interactive = true;

    this.viewComponent.view.on('pointerdown', this.handleClick);
  }

  private handleClick = (e: FederatedPointerEvent): void => {
    if (!this.viewComponent || !this.dataComponent) return;

    if (this.dataComponent.isInteractiveDisabled(e)) {
      this.clickerEvents.emitEvent(ClickerGameEventNames.AnyTap);

      return;
    }

    this.dataComponent.handleClick(e);

    this.destroyEffect?.emitterPoolComponent.emitWave(e.screen);

    // const points = this.clickerStateStore.getPointsByEnergy(ASTEROID_CLICK_ENERGY);
    // this.pointsEmitter?.emitterComponent.spawnPoints(points, e.screen);

    this.audioPlayer.playClickSound(ClickerSoundsBundle.TapComet);

    this.healthComponent?.addHealth(-1);

    if (this.healthComponent?.isDead()) {
      this.audioPlayer.playExtraSound(ClickerSoundsBundle.KotletkaTapComet);
      this.spaceship?.animationComponent.playFireflies();
      this.gameObject.setAsDestroyed();
    }

    this.clickerEvents.emitEvent(ClickerGameEventNames.Tap);
    this.clickerEvents.emitEvent(ClickerGameEventNames.AnyTap);

    this.vibration.vibrate(VIBRATE_TIME);
  };
}

injected(
  AsteroidInteractiveComponent,
  DI_TOKENS.clickerGameAudioPlayer,
  DI_TOKENS.clickerGameEvents,
  DI_TOKENS.vibration,
);
